import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { catchError, map, throwError } from 'rxjs';
interface RelatedIds {
  id: number;
  id_next: number | null;
  id_prev: number | null;
}
@Injectable({
  providedIn: 'root'
})
export class EquipoService {
  endpointApi = environment.apiCmsTeam;
  endpointApiStatic = environment.apiCmsTeamStatic;
  endpointApiCareer = environment.apiCmsCareer;

  teamMembers: any;
  teamMember: any;

  sharedData: any;

  size: number = 10000;
  page: number = 0;
  constructor(private http: HttpClient) { }

  // Handle API errors =================================
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  getTeamStatic() {
    return this.http.get<any>(this.endpointApiStatic + '/get?id=1')
      .pipe(
        map(resp => {
          return resp.data.team;
        }),
        catchError(this.handleError)
      );
  }
  getCareersStatic() {
    return this.http.get<any>(this.endpointApiCareer + '/get?id=1')
      .pipe(
        map(resp => resp.data.career),
        catchError(this.handleError)
      )
  }


  getTeamMembersItems() {
    return this.http.get<any>(this.endpointApi + '/list?size=' + this.size)
      .pipe(
        map(resp => {
          return resp;
        }),
        catchError(this.handleError)
      );
  }

  getTeamMember(id: number) {
    this.teamMember = this.http.get<any>(this.endpointApi + '/find?id=' + id)
      .pipe(
        map(resp => {
          return resp;
        }),
        catchError(this.handleError)
      )
    return this.teamMember;
  }

  setSharedData(data: any) {
    this.sharedData = data;
  }

  getSharedMembers() {
    const temp = this.teamMembers;
    return temp;
  }





}
